const inlineFilterItems = [
  {
    id: 'all',
    label: "Semua",
  },
  {
    id: "ACTIVE",
    label: "Aktif",
  },
  {
    id: "INACTIVE",
    label: "Non Aktif",
  },
];

export default inlineFilterItems;
